import { Controller } from 'stimulus';
import { roundDecimal } from '@/js/modules/billable-utils';

export default class extends Controller {
  static targets = [
    'amount',
    'paymentMethod',
    'billToggle',
    'billToggleDisabled',
    'billCheckbox',
    'paymentsToggle',
    'paymentsToggleDisabled',
    'paymentsCheckbox',
    'bankAccount',
    'creditCardAccount',
  ];

  static values = { convertToBill: Boolean, convertPayments: Boolean };

  connect() {
    this.amountChanged();
  }

  amountChanged() {
    this.#syncBillToggle();
    this.convertToBillChanged();
  }

  convertToBillChanged() {
    this.#syncPaymentsToggle();
    this.#syncAccountFields();
  }

  convertPaymentsChanged() {
    this.#syncAccountFields();
  }

  paymentMethodChanged() {
    this.#syncAccountFields();
  }

  #syncBillToggle() {
    if (!this.hasBillToggleTarget) {
      return;
    }

    const amount = roundDecimal(parseFloat(this.amountTarget.value));
    const hasAmount = !isNaN(amount) && amount !== 0;

    this.billToggleTarget.classList.toggle('hide', !hasAmount);
    this.billToggleDisabledTarget.classList.toggle('hide', hasAmount);

    if (!hasAmount) {
      this.billCheckboxTarget.checked = false;
    } else if (this.convertToBillValue) {
      this.billCheckboxTarget.checked = true;
    }
  }

  #syncPaymentsToggle() {
    if (!this.hasPaymentsToggleTarget) {
      return;
    }

    const convertToBill = this.hasBillCheckboxTarget && this.billCheckboxTarget.checked;

    this.paymentsToggleTarget.classList.toggle('hide', !convertToBill);
    this.paymentsToggleDisabledTarget.classList.toggle('hide', convertToBill);

    if (!convertToBill) {
      this.paymentsCheckboxTarget.checked = false;
    } else if (this.convertPaymentsValue) {
      this.paymentsCheckboxTarget.checked = true;
    }
  }

  #syncAccountFields() {
    if (!this.hasBankAccountTarget) {
      return;
    }

    const convertPayments = this.hasPaymentsCheckboxTarget && this.paymentsCheckboxTarget.checked;
    const creditCard = this.paymentMethodTarget.value === 'credit_card';

    this.bankAccountTarget.classList.toggle('hide', !convertPayments || creditCard);
    this.creditCardAccountTarget.classList.toggle('hide', !convertPayments || !creditCard);
  }
}
